module.exports = __webpack_public_path__ + "img/tooltip_ask.6aa9850f.svg";